// Dünner Wrapper um Plausible-Custom-Events.
//
// Plausible wird nur geladen, wenn der Build mit REACT_APP_PLAUSIBLE_DOMAIN /
// REACT_APP_ANALYTICS_URL gebaut wurde (siehe public/index.html). Ist das nicht
// der Fall (lokale Builds, Adblocker), bleibt `window.plausible` undefiniert und
// alle Aufrufe hier sind ein stiller No-op. Tracking darf den Nutzer-Flow niemals
// stören — deshalb ist alles in try/catch gekapselt und wirft nie.
//
// Custom Events müssen im Plausible-Dashboard als Ziele („Goals") angelegt werden,
// damit sie in Auswertungen erscheinen.

// Zentrale Event-Namen für den anonymen CyberRisikoCheck (Start → Abschluss-Funnel;
// „Abandoned" ist ein Best-Effort-Signal, die verlässliche Abbruchquote ergibt sich
// aus dem Drop-off Started − Completed).
export const ANON_CHECK_EVENTS = {
  started: 'Anon Check: Started',
  completed: 'Anon Check: Completed',
  abandoned: 'Anon Check: Abandoned',
};

export function trackEvent(name, props) {
  try {
    if (typeof window === 'undefined' || typeof window.plausible !== 'function') return;
    window.plausible(name, props ? { props } : undefined);
  } catch {
    // bewusst geschluckt — Analytics darf den Flow nie brechen
  }
}
